import React from 'react';
import { Outlet } from 'react-router';

function BlankLayout() {
  return <Outlet />;
}

export default React.memo(BlankLayout);
